module.exports = __webpack_public_path__ + "img/program_icon01.cd7fa87b.png";